export var regex = {
    personName: /^[A-Za-z][A-Za-z'-]+([A-Za-z][A-Za-z'-]+)*/,
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    zipCode: /^([0-9]{5})$/g,
    phoneNumber: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g,
    year: /^\d{4}$/,
};
